module.exports = __webpack_public_path__ + "img/en.6456fd06.jpg";